<template>
  <header class="grid grid-cols-12 overflow-x-hidden" data-component="HeaderHome">
    <div class="2xl:col-end-12 col-end-13 col-start-7 row-end-6 row-start-1 sm:col-end-13 lg:col-end-13">
      <figure v-if="image" class="-mr-16 2xl:-mr-20 sm:ml-0 lg:-mr-20 xl:-mr-20">
        <MoleculePicture class="block w-full" :image="image" />
      </figure>
    </div>
    <div class="col-end-12 col-start-1 row-end-5 row-start-2 pt-12 sm:col-end-8 sm:row-end-auto sm:row-start-3 md:pt-0 lg:pt-10 xl:row-start-2 xl:pt-24">
      <div class="flex flex-col items-start">
        <div v-if="title" class="inline-flex mr-12 p-4 bg-white rounded-tr-xl md:p-6 lg:p-8 xl:p-12">
          <h2 class="text-lg text-black font-black leading-none uppercase md:text-xl md:font-bold lg:text-2xl xl:text-4xl">{{ title }}</h2>
        </div>
        <h1
          v-if="subtitle"
          class="inline-flex p-4 text-black font-black leading-none bg-app-green rounded-r-xl uppercase sm:ml-4 sm:rounded-b-xl md:ml-6 md:p-6 md:text-3xl md:font-bold lg:ml-8 lg:p-8 lg:text-4xl xl:ml-12 xl:p-12 xl:text-5xl"
          :class="{ 'text-2xl': subtitle.length < 16, 'text-xl': subtitle.length >= 16 }"
        >
          {{ subtitle }}
        </h1>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
interface Props {
  title: string
  subtitle?: string
  image?: object
}

defineProps<Props>()
</script>
